import {V3Record} from 'data/helpers/V3Record.js'

export const ExperienceMessage = V3Record('experienceMessage', {
  experienceId: null,
  content: '',
  createdAt: null
})
